import { gql } from "@apollo/client";

export const GET_PRECIO_AUTORIZADORES = gql`
query QGetGestionPrecioAutorizadores {
    gestionPrecioAutorizadores {
        idUsuario,
        apellido,
        nombre,
        usuario
        email
    }
}
`;